import { render, staticRenderFns } from "./NuevoPrecioModeloV2.vue?vue&type=template&id=62b65b18"
import script from "./NuevoPrecioModeloV2.vue?vue&type=script&lang=js"
export * from "./NuevoPrecioModeloV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports